import { MarkerType } from "@xyflow/react"
import { v4 as uuidv4 } from "uuid"

import { WorkflowEdge } from "lib/types/workflow"

export const makeEdge = (
  source: string,
  sourceHandle: string | null | undefined,
  target: string,
  targetHandle: string | null | undefined
): WorkflowEdge => ({
  id: uuidv4(),
  source,
  sourceHandle: sourceHandle ?? null,
  target,
  targetHandle: targetHandle ?? null,
  markerEnd: { type: MarkerType.ArrowClosed },
  animated: true
})
